<div class="modal-wrapper">
  @if (title) {
    <div
      class="modal-title"
      [style]="{
        color: title.color,
        fontFamily: title.fontFamily,
      }"
      [innerHTML]="title.label | safe"
    ></div>
  }

  @if (body) {
    <div
      class="modal-body"
      [style]="{
        color: body.color,
        fontFamily: body.fontFamily,
      }"
      [innerHTML]="
        body.label! | replaceVars: data.minAmountByTransaction | safe
      "
    ></div>
  }

  <div class="modal-footer justify-content-center mt-3">
    <b2c-button
      class="close-btn"
      data-cy="close_btn"
      (click)="closeDialog()"
      [styles]="{
        color: closeButtonConfig.textColor,
        borderRadius: closeButtonConfig.borderRadius,
        backgroundColor: closeButtonConfig.backgroundColor,
        borderColor:
          closeButtonConfig.borderColor || closeButtonConfig.backgroundColor,
      }"
    >
      {{ closeButtonConfig.label }}</b2c-button
    >
  </div>
</div>
